// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"notFound_notFoundContainer__gxnkt","notFoundContent":"notFound_notFoundContent__kbWv-"};